// components/AuthRoleGuard.tsx
import { Navigate } from "react-router-dom";
import { getRoleIdFromToken, isAuthenticated } from "../utils/getRoleIdFromToken";

interface AuthRoleGuardProps {
	children: React.ReactElement;
	allowedRoleIds: number[];
}

export default function AuthRoleGuard({ children, allowedRoleIds }: AuthRoleGuardProps) {
	if (!isAuthenticated()) {
		return <Navigate to="/login" replace />;
	}

	const token = sessionStorage.getItem("Token");
	const roleId = getRoleIdFromToken(token);

	if (roleId === null || !allowedRoleIds.includes(roleId)) {
		return <Navigate to="/unauthorized" replace />;
	}

	return children;
}
